export default "__VITE_ASSET__DA6YS1b1__"